






import Vue from 'vue';

export default Vue.extend({
  name: "BlackMarketMain2d",
  data: () => {
    return {};
  },
});
